import {Theme} from "@core-ui/react-stitch";
import {
  ComposableButtonInteractiveConfig,
  ComposableButtonBaseProps,
  Variant,
} from "../../types";
import {getActiveButtonColor} from "../../styles/helpers";

// current Gap & Gapfs designs have the two brands as exactly the same, and focus & active styles as exactly the same, unlike AT & ON focus & active
const gapInteractiveStylesConfig = (
  props: Partial<ComposableButtonBaseProps> & {theme: Theme}
): ComposableButtonInteractiveConfig => {
  const {primary, secondary} = getActiveButtonColor(props);

  return {
    hoverFocus: {
      [Variant.border]: {
        "&:hover, &:focus": {
          color: secondary,
          backgroundColor: primary,
          borderColor: primary,
        },
      },
      [Variant.chevron]: {
        "&:hover, &:focus": {
          textDecoration: "underline",
        },
      },
      [Variant.flat]: {
        "&:hover, &:focus": {
          textDecoration: "underline",
        },
      },
      [Variant.solid]: {
        "&:hover, &:focus": {
          color: primary,
          backgroundColor: secondary,
          borderColor: primary,
        },
      },
      [Variant.outline]: {
        "&:hover, &:focus": {
          color: secondary,
          backgroundColor: primary,
          borderColor: primary,
        },
      },
      [Variant.underline]: {
        "&:hover, &:focus": {
          textDecoration: "unset",
        },
      },
    },
    active: {
      [Variant.border]: {
        "&:active": {
          color: secondary,
          backgroundColor: primary,
          borderColor: primary,
        },
      },
      [Variant.chevron]: {
        "&:active": {
          textDecoration: "underline",
        },
      },
      [Variant.flat]: {
        "&:active": {
          textDecoration: "underline",
        },
      },
      [Variant.solid]: {
        "&:active": {
          color: primary,
          backgroundColor: secondary,
          borderColor: primary,
        },
      },
      [Variant.outline]: {
        "&:active": {
          color: secondary,
          backgroundColor: primary,
          borderColor: primary,
        },
      },
      [Variant.underline]: {
        "&:active": {
          textDecoration: "unset",
        },
      },
    },
  };
};

export default gapInteractiveStylesConfig;
